import React, { FC } from 'react';
import styles from './index.less';
import title1 from '@/assets/image/title1.png';
import title2 from '@/assets/image/title2.png';
import title3 from '@/assets/image/title3.png';

interface ComProps {
  type: 1 | 2 | 3;
  style?: React.CSSProperties;
}

const ImgObj: any = {
  1: title1,
  2: title2,
  3: title3,
}

const Title: FC<ComProps> = ({
  type,
  style,
}) => {

  return (
    <div className={styles.titleWrapper} style={style}>
      <img src={ImgObj[type]} alt="" />
    </div>
  );
};

export default Title;
